import React from 'react';
import { connect, ConnectedProps } from "react-redux"
import { GlobalApplicationState } from "globalApplicationState"
import { MessagingTabs } from "../models";
import { actions } from "modules/messaging";
import BasePage from "pages/common/basePage";
import Header from "pages/common/header";
import MainContent from "pages/common/mainContent";
import { audiencesApi, messagingApi } from 'api/instances';
import { Audience } from 'modules/audiences/models';
import { push } from 'connected-react-router';
import MessagingCenterTeamsTab from './messagingCenterTeamsTab';
import MessagingCenterMobileTab from './messagingCenterMobileTab';

import '../messaging.sass';
import '../../common/components/textAreaLanguageSelector.sass';

interface ComponentProps { }

interface ComponentState { 
    audiences: Audience[];
    userTeamsStats: UserTeamsStats;
    userMobileStats: UserMobileStats;
}

interface UserTeamsStats {
    totalUsers: number,
    registeredUsers: number
}

interface UserMobileStats {
    activeDevices: number,
    usersWithApp: number,
    usersWithNoDevice: number
}

class MessagingCenterScreen extends React.Component<PropsWithRedux, ComponentState> {

    componentDidMount() {
        audiencesApi.getAllAudiences()
        .then((audiences) => {
            this.setState({
                ...this.state,
                audiences: audiences
            })
        })

        messagingApi.GetTeamsStats()
        .then((stats) => {
            this.setState({
                ...this.state,
                userTeamsStats: stats
            })
        })

        messagingApi.GetMobileStats()
        .then((stats) => {
            this.setState({
                ...this.state,
                userMobileStats: stats
            })
        })
    }

    constructor(props) {
        super(props)
        this.state = {
            audiences: [],
            userTeamsStats: {
                totalUsers: 0,
                registeredUsers: 0
            },
            userMobileStats: {
                activeDevices: 0,
                usersWithApp: 0,
                usersWithNoDevice: 0
            }
        }
    }

    public render() {

        const teamsTabActive = this.props.activeTab === MessagingTabs.Teams ? " active" : "";
        const mobileTabActive = this.props.activeTab === MessagingTabs.Mobile ? " active" : "";

        return (
            <BasePage fullWidth>
                <Header
                    title="Direct Messaging"
                />
                <MainContent>
                    <div className="messaging-center-page">
                        <div className="tab-clearfix">
                            <ul style={{float: "left"}} className="tab-btns">
                                <li>
                                    <span className={`tab-btn ${teamsTabActive}`}
                                        onClick={() => {this.handleTabChange(MessagingTabs.Teams)}}>
                                        Teams
                                    </span>    
                                </li>  
                                <li>
                                    <span className={`tab-btn ${mobileTabActive}`}
                                        onClick={() => {this.handleTabChange(MessagingTabs.Mobile)}}>
                                        Mobile
                                    </span>
                                </li>
                            </ul>
                        </div>
                        {teamsTabActive &&
                            <div className={`tab non-list-view ${teamsTabActive}`}>
                                <MessagingCenterTeamsTab
                                    navigateToSettings={this.navigateToSettings}
                                    userTeamsStats={this.state.userTeamsStats}
                                />
                            </div>
                        }
                        {mobileTabActive &&
                            <div className={`tab non-list-view ${mobileTabActive}`}>
                                <MessagingCenterMobileTab
                                    navigateToSettings={this.navigateToSettings}
                                    userMobileStats={this.state.userMobileStats}
                                    currentUser={this.props.currentUser}
                                />
                            </div>
                        }
                    </div>
                </MainContent>
            </BasePage>
        );
    }

    private handleTabChange = (tab: MessagingTabs) => {
        this.props.setActiveTab(tab)
    }
    private navigateToSettings = () => {
        this.props.redirectTo('/' + this.props.tenantId + '/admin/settings#messaging')
    }
}


const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        activeTab: state.messaging.activeTab,
        tenantId: state.tenant.id,
        currentUser: state.settings.currentUser
    }),
    {
        setActiveTab: actions.setActiveTab,
        redirectTo: push,
    }
);
type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(MessagingCenterScreen)
